export function GetLanguagename(ID) {
    const LOptions = JSON.parse(localStorage.getItem("LanguageOptions"));
    const Name = LOptions?.find((item) => item.value == ID)?.display;
    switch (Name) {
        case "English":
            return ["en",Name];
        case "Hindi":
            return ["hi",Name];
        case "Telugu":
            return ["te",Name];
    }
}